var React = require('react');

function DeliveryInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.915 12a1.5 1.5 0 1 1-2.83 0h-5.17a1.5 1.5 0 1 1-2.83 0H1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v2h2.129a1 1 0 0 1 .75.34l1.871 2.124a1 1 0 0 1 .25.661V11a1 1 0 0 1-1 1h-2.085zm-1.913-3H14v-.497L12.677 7h-1.67l-.005 2z","fill":"currentColor","fillRule":"evenodd"}));
}

DeliveryInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = DeliveryInline;

DeliveryInline.default = DeliveryInline;
